import { EventBus } from '@/util/eventBus';
import { apiAliyunSts } from '@/request/api';
import { Decimal } from 'decimal.js';
import OSS from 'ali-oss';

export default {
  copyToClip(that, content, message) {
    const aux = document.createElement('input');
    aux.setAttribute('value', content);
    document.body.appendChild(aux);
    aux.select();
    document.execCommand('copy');
    document.body.removeChild(aux);
    if (message == null) {
      that.$message.showMsgBox({
        type: 'success',
        content: '链接复制成功',
      });
    } else {
      that.$message.showMsgBox({
        type: 'success',
        content: message,
      });
    }
  },
  // 存储本地数据
  saveTodos(key, todos, times = 0, startTimes = 0) {
    const todosArr = todos;
    try {
      if (todosArr) {
        if (times) {
          todosArr.overTimes = times;
          if (startTimes !== 0) {
            todosArr.startTimes = startTimes;
          } else {
            todosArr.startTimes = Date.parse(new Date());
          }
        }
        // 执行存储
        window.localStorage.setItem(key, JSON.stringify(todosArr));
      } else {
        // 执行删除
        window.localStorage.removeItem(key);
      }
      return true;
    } catch (e) {
      console.log(e, '===============');
      return false;
    }
  },
  truncateArray(arr, n) {
    return arr.slice(0, n);
  },
  // 获取本地数据
  readTodos(key) {
    try {
      let item = window.localStorage.getItem(key);
      item = item !== null ? item : '{}';
      return JSON.parse(item || '[]');
    } catch (e) {
      return JSON.parse('[]');
    }
  },
  trimSymbol(str, symbol) {
    const regex = new RegExp(`^[${symbol}]+|[${symbol}]+$`, 'g');
    return str.replace(regex, '');
  },
  // 距离时间
  colorInterview(times) {
    // 获取当前时间戳
    const shijainchuo = Date.parse(new Date()) / 1000;
    let style;
    // 24小时内
    if (shijainchuo <= times && (shijainchuo + 86400) >= times) {
      style = 1;
    } else if (shijainchuo <= times && (shijainchuo + (86400 * 3)) >= times) {
      // 3天内
      style = 2;
    } else if ((shijainchuo + (86400 * 3)) <= times) {
      // 等待中
      style = 3;
    } else {
      // 等待中
      style = 4;
    }
    return style;
  },
  wenhouStr() {
    // 获取当前时间
    const timeNow = new Date();
    // 获取当前小时
    const hours = timeNow.getHours();
    // 设置默认文字
    let text = '';
    // 判断当前时间段
    if (hours >= 0 && hours <= 11) {
      text = '早上好';
    } else if (hours > 11 && hours <= 13) {
      text = '中午好';
    } else if (hours > 13 && hours <= 18) {
      text = '下午好';
    } else if (hours > 18 && hours <= 24) {
      text = '晚上好';
    }
    // 返回当前时间段对应的状态
    return text;
  },
  whereArrStr(arr) {
    if (arr) {
      if (arr instanceof Array) {
        const strArr = [];
        arr.forEach((app) => {
          strArr.push(app.id);
        });
        return strArr.join();
      }
      return arr.id;
    }
    return '';
  },
  isMobile() {
    const ua = navigator.userAgent;
    const isWindowsPhone = /(?:Windows Phone)/.test(ua);
    const isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone;
    const isAndroid = /(?:Android)/.test(ua);
    const isFireFox = /(?:Firefox)/.test(ua);
    const isChrome = /(?:Chrome|CriOS)/.test(ua);
    const isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua));
    const isPhone = /(?:iPhone)/.test(ua) && !isTablet;
    const isPc = !isPhone && !isAndroid && !isSymbian;
    return {
      isTablet,
      isPhone,
      isAndroid,
      isPc,
    };
  },
  // 图片大小
  calculateSizeFun(limit) {
    let size = '';
    if (limit < 0.1 * 1024) { // 小于0.1KB，则转化成B
      size = `${limit.toFixed(2)}B`;
    } else if (limit < 0.1 * 1024 * 1024) { // 小于0.1MB，则转化成KB
      size = `${(limit / 1024).toFixed(2)}KB`;
    } else if (limit < 0.1 * 1024 * 1024 * 1024) { // 小于0.1GB，则转化成MB
      size = `${(limit / (1024 * 1024)).toFixed(2)}MB`;
    } else { // 其他转化成GB
      size = `${(limit / (1024 * 1024 * 1024)).toFixed(2)}GB`;
    }
    const sizeStr = `${size}`; // 转成字符串
    const index = sizeStr.indexOf('.'); // 获取小数点处的索引
    const dou = sizeStr.substr(index + 1, 2); // 获取小数点后两位的值
    if (dou === '00') { // 判断后两位是否为00，如果是则删除00
      return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2);
    }
    return size;
  },
  makeTupianOneImgShard(vueOb, files, data, ishideCall = false) {
    const that = this;
    // 判断是否是静默调取
    if (!ishideCall) {
      EventBus.$emit('globalLoadingFun', { bool: true, loading: true });
      vueOb.loadingSize = '0B';
      vueOb.is_loading = true;
      vueOb.loadingProgress = 2;
      vueOb.loadingSize = this.calculateSizeFun(files.size);
    }
    apiAliyunSts({ }).then((ob) => {
      if (ob.state === 1) {
        const ossClient = new OSS({
          // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
          region: ob.data.region,
          // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
          accessKeyId: ob.data.AccessKeyId,
          accessKeySecret: ob.data.AccessKeySecret,
          // 从STS服务获取的安全令牌（SecurityToken）。
          stsToken: ob.data.SecurityToken,
          // 填写Bucket名称，例如examplebucket。
          bucket: ob.data.bucket,
          refreshSTSToken: async () =>
            // 向您搭建的STS服务获取临时访问凭证 - 如果超时
            apiAliyunSts({ }).then(ob => ({ accessKeyId: ob.data.AccessKeyId, accessKeySecret: ob.data.AccessKeySecret, stsToken: ob.data.SecurityToken })).catch((ob) => {
              // 判断是否是静默调取
              if (!ishideCall) {
                vueOb.$message.showMsgBox({
                  type: 'warning',
                  content: '上传失败B-5555',
                });
                vueOb.is_loading = false;
                EventBus.$emit('globalLoadingFun', { bool: false, loading: false });
              }
            }),
          // 刷新临时访问凭证的时间间隔，单位为毫秒。
          refreshSTSTokenInterval: 900000,
        });
        // // 定义文件名
        const fileName = `${that.stringToHex(ob.data.user_md5)}.${that.getFileType(files.name)}`;
        // 服务器回调地址
        const callbackUrl = ob.data.callback;
        // 执行分片上传
        const result = ossClient.multipartUpload(fileName, files, {
          progress(p, checkpoint) {
            // 判断是否是静默调取
            if (!ishideCall) {
              vueOb.loadingProgress = (p * 100).toFixed(0);
            }
          },
          meta: { year: 2020, people: 'test' },
          mime: files.type,
          partSize: 131072,
          callback: {
            url: callbackUrl,
            host: '',
            /* eslint no-template-curly-in-string: [0] */
            body: 'filename=${object}&size=${size}&mimeType=${mimeType}&height=${imageInfo.height}&width=${imageInfo.width}&token=${x:token}&type=${x:type}&oldFileName=${x:oldFileName}',
            contentType: 'application/x-www-form-urlencoded',
            customValue: {
              token: data.token, // 唯一识别号ID
              type: data.type, // 文件所属标识
              oldFileName: files.name, // 原文件名
            },
          },
        }).then((ob) => {
          if (ob.res.status === 200 && ob.data.state === 2) {
            // 执行回调函数
            if (data.initFun) {
              data.initFun(ob.data);
            }
            // 判断是否是静默调取
            if (!ishideCall) {
              vueOb.$message.showMsgBox({
                type: 'success',
                content: '上传成功',
              });
              vueOb.is_loading = false;
              EventBus.$emit('globalLoadingFun', { bool: false, loading: false });
            }
          } else {
            // 失败回调函数
            if (data.initErrorFun) {
              data.initErrorFun({ state: 201, message: '上传失败B-4444', data: {} });
            }
            // 判断是否是静默调取
            if (!ishideCall) {
              vueOb.$message.showMsgBox({
                type: 'warning',
                content: '上传失败B-4444',
              });
              vueOb.is_loading = false;
              EventBus.$emit('globalLoadingFun', { bool: false, loading: false });
            }
          }
        }).catch((ob) => {
          console.log(ob);
          // 失败回调函数
          if (data.initErrorFun) {
            data.initErrorFun({ state: 201, message: '上传失败B-11112', data: {} });
          }
          // 判断是否是静默调取
          if (!ishideCall) {
            vueOb.$message.showMsgBox({
              type: 'warning',
              content: '上传失败B-1111',
            });
            vueOb.is_loading = false;
            EventBus.$emit('globalLoadingFun', { bool: false, loading: false });
          }
        });
      } else {
        // 失败回调函数
        if (data.initErrorFun) {
          data.initErrorFun({ state: 201, message: '上传失败B-3333', data: {} });
        }
        // 判断是否是静默调取
        if (!ishideCall) {
          vueOb.$message.showMsgBox({
            type: 'warning',
            content: '上传失败B-3333',
          });
          vueOb.is_loading = false;
          EventBus.$emit('globalLoadingFun', { bool: false, loading: false });
        }
      }
    }).catch((ob) => {
      // 失败回调函数
      if (data.initErrorFun) {
        data.initErrorFun({ state: 201, message: '上传失败B-2222', data: {} });
      }
      // 判断是否是静默调取
      if (!ishideCall) {
        vueOb.$message.showMsgBox({
          type: 'warning',
          content: '上传失败B-2222',
        });
        vueOb.is_loading = false;
        EventBus.$emit('globalLoadingFun', { bool: false, loading: false });
      }
    });
  },
  // 获取十六进制字符串
  stringToHex(str) {
    let strr = '';
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < 3; i++) {
      const number = `${Math.ceil(Math.random() * 9)}`;
      strr += number;
    }
    const dateOb = new Date().getTime();
    return `${str}/${(dateOb + strr).split('').reverse().join('')}`;
  },
  // 获取文件后缀名
  getFileType(filePath) {
    const startIndex = filePath.lastIndexOf('.');
    if (startIndex !== -1) {
      return filePath.substring(startIndex + 1, filePath.length).toLowerCase();
    }
    return '';
  },
  isNumber(value) {
    return typeof value === 'number' && !isNaN(value);
  },
  isPositiveInteger(number) {
    number *= 1;
    return typeof number === 'number' && !isNaN(number);
  },
  isNonNegativeInteger(value) {
    return /^\d+$/.test(String(value));
  },
  // today1函数同理
  today() {
    const today = new Date();
    const h = today.getFullYear();
    let m = today.getMonth() + 1;
    let d = today.getDate();
    let hh = today.getHours();
    let mm = today.getMinutes();
    let ss = today.getSeconds();
    m = m < 10 ? `0${m}` : m;
    d = d < 10 ? `0${d}` : d;
    hh = hh < 10 ? `0${hh}` : hh;
    mm = mm < 10 ? `0${mm}` : mm;
    ss = ss < 10 ? `0${ss}` : ss;
    return `${h}-${m}-${d} ${hh}:${mm}:${ss}`;
  },
  // 减法运算
  subtrNumber(arg1, arg2) {
    const a2 = arg1 * 1;
    const b2 = arg2 * 1;
    const c2 = new Decimal(a2).sub(new Decimal(b2));
    return c2.toDecimalPlaces(2, Decimal.ROUND_HALF_UP).toString();
  },
  // 乘法
  accMulNumber(arg1, arg2) {
    const a3 = arg1 * 1;
    const b3 = arg2 * 1;
    const c3 = new Decimal(a3).mul(new Decimal(b3));
    return c3.toDecimalPlaces(2, Decimal.ROUND_HALF_UP).toString();
  },
  // 除法
  divideNumber(arg1, arg2) {
    const a4 = arg1 * 1;
    const b4 = arg2 * 1;
    const c4 = new Decimal(a4).div(new Decimal(b4));
    return c4.toDecimalPlaces(2, Decimal.ROUND_HALF_UP).toString();
  },
  // 加法
  accAddNumber(arg1, arg2) {
    const a1 = arg1 * 1;
    const b1 = arg2 * 1;
    const c1 = new Decimal(a1).add(new Decimal(b1));
    return c1.toDecimalPlaces(2, Decimal.ROUND_HALF_UP).toString();
  },
  currentTime() {
    const currentDate = new Date();
    const year = currentDate.getFullYear();// 获取当前年
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');// 获取当前月
    const firstDay = '01';// 日
    return `${year}-${month}-${firstDay}`;
  },
  getLastDayOfNaturalMonth() {
    // 获取当前日期
    const currentDate = new Date();
    // 获取当前年份
    let year = currentDate.getFullYear();
    // 获取下个月的月份，使用 padStart 在月份小于 10 时在前面补零
    let month = String(currentDate.getMonth() + 2).padStart(2, '0');
    // 如果月份为 '13'，说明当前是12月，需要更新年份并将月份设置为 '01'
    if (month === '13') {
      year += 1;
      month = '01';
    }
    // 设置每个月的第一天为 '01'
    const firstDay = '01';
    // 构建下个月的第一天的日期字符串，格式为 'YYYY-MM-DD'
    const firstDayOfNextMonth = `${year}-${month}-${firstDay}`;
    // 计算当前月的最后一天，通过减去一天的毫秒数来得到
    const lastDayOfMonth = new Date(new Date(firstDayOfNextMonth).getTime() - 86400000);
    // 将最后一天的日期转换为 ISO 格式，并提取日期部分
    return lastDayOfMonth.toISOString().split('T')[0];
  },
  deepClone(obj) {
    if (obj === null || typeof obj !== 'object') {
      return obj;
    }
    if (Array.isArray(obj)) {
      const copy = [];
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < obj.length; i++) {
        copy[i] = this.deepClone(obj[i]);
      }
      return copy;
    }
    const copy = {};
    // eslint-disable-next-line no-restricted-syntax
    for (const key in obj) {
      // eslint-disable-next-line no-prototype-builtins
      if (obj.hasOwnProperty(key)) {
        copy[key] = this.deepClone(obj[key]);
      }
    }
    return copy;
  },

};



// WEBPACK FOOTER //
// ./src/util/commons.js